<template>
  <div
    :style="styles"
    class="drop-file"
    @drag.stop.prevent=""
    @dragover.stop.prevent=""
    @dragstart.stop.prevent="startDrag"
    @dragenter.stop.prevent="startDrag"
    @dragend.stop.prevent="stopDrag"
    @dragleave.stop.prevent="stopDrag"
    @drop.stop.prevent="handleDrop"
    @click="chooseFiles"
  >
    <p class="ma-0">Arraste ou clique para anexar documentos</p>
    <input
      ref="finput"
      type="file"
      :style="{ display: 'none' }"
      :multiple="multiple"
      @change="handleFiles"
      :disabled="disabled"
      :accept="formatFilesAcceptable"
    />
  </div>
</template>

<script>
const canDragAndDrop = (() => {
  const div = document.createElement("div");
  return "draggable" in div || ("ondragstart" in div && "ondrop" in div);
})();

export default {
  name: "DropFile",
  props: {
    height: { type: String, default: "100px" },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    formatFilesAcceptable: { type: String, default: "*" }
  },
  computed: {
    styles() {
      return { height: this.height };
    }
  },
  data() {
    return { isDraggging: false };
  },
  methods: {
    startDrag() {
      this.isDragging = !canDragAndDrop;
    },
    stopDrag() {
      this.isDragging = false;
    },
    handleDrop(e) {
      if (this.disabled) return;
      this.stopDrag();
      this.$emit("selected-files", Array.from(e.dataTransfer.files));
    },
    handleFiles(e) {
      if (this.disabled) return;
      this.$emit("selected-files", Array.from(e.target.files));
      e.target.value = null;
    },
    chooseFiles() {
      this.$refs.finput.click();
    }
  }
};
</script>

<style lang="sass">
.drop-file
  display: flex
  align-items: center
  justify-content: center
  border-radius: 2px
  border: 2px dashed #D5D5E0
  color: #676778
</style>
